<template>
  <div class="page-wrapper basic-rules" >
    <Form :model="savaData" :rules="formRules" ref="rulusForm" >
      <Select v-model="savaData.projectFid" class="item-width" @on-change="changeProject">
        <Option v-for="item in projectList" :value="item.value" :key="item.value">{{item.text}}</Option>
      </Select>
      <div class="rules mt-36">
        <div class="rules-item">
          租期定义
        </div>
        <div class="rules-detail">
          <Row :gutter="16">
            <Col span="8">
              <span class="label">年租：</span>
              <FormItem label="" prop="rentTermYearStart" >
                <Input v-model="savaData.rentTermYearStart" size="small" :disabled="isRead">
                </Input>
              </FormItem>
              <div class="dash"><span></span></div>
              <FormItem label="" prop="rentTermYearEnd" >
                <Input v-model="savaData.rentTermYearEnd" size="small" :disabled="isRead"></Input>
              </FormItem>
              <span>年</span>
              <!-- <div class="error-color" :class="{block:rentTermYearEndErr || rentTermYearStartErr}">请输入正确的数字</div> -->
            </Col>
            <Col span="8">
              <span class="label">月租：</span>
              <FormItem label="" prop="rentTermMonthStart" >
                <Input v-model="savaData.rentTermMonthStart" size="small" :disabled="isRead"></Input>
              </FormItem>
              <div class="dash"><span></span></div>
              <FormItem label="" prop="rentTermMonthEnd" >
                <Input v-model="savaData.rentTermMonthEnd" size="small" :disabled="isRead"></Input>
              </FormItem>
              <span>日</span>
              <!-- <div class="error-color" :class="{block:rentTermMonthStartErr || rentTermMonthEndErr}">请输入正确的数字</div> -->
            </Col>
            <Col span="8">
              <span class="label">尾房：</span>
              <span>签约日距出租截止日不足1个自然年</span>
            </Col>
          </Row>
        </div>
      </div>
      <div class="rules">
        <div class="rules-item">
          标准押金
        </div>
        <div class="rules-detail">
          <Row :gutter="16">
            <Col span="8">
              <span class="label">年租：</span>
              <span>实际月租金 * </span>
              <FormItem label="" prop="depositYearValue" class="w-80">
                <Select v-model="savaData.depositYearValue"size="small" :disabled="isRead">
                  <Option v-for="item in monthList" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <span class="label">月租：</span>
              <span>实际月租金 * </span>
              <FormItem label="" prop="depositMonthValue" class="w-80">
                <Select v-model="savaData.depositMonthValue" size="small" :disabled="isRead">
                  <Option v-for="item in monthList" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <span class="label">尾房：</span>
              <span>实际月租金 * </span>
              <FormItem label="" prop="depositTailValue" class="w-80">
                <Select v-model="savaData.depositTailValue" size="small" :disabled="isRead">
                  <Option v-for="item in monthList" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>

        </div>
      </div>

      <div class="rules">
        <div class="rules-item">
          房租调幅：租期
        </div>
        <div class="rules-detail">
          <Row :gutter="16">
            <Col span="8">
              <span class="label">年租：</span>
              <span>标准月租金 * </span>
              <FormItem label="" prop="waveRentTermYear" class="w-80">
                <Input v-model="savaData.waveRentTermYear" size="small" :disabled="isRead">
                  <span slot="append">%</span>
                </Input>
              </FormItem>
            </Col>
            <Col span="8">
              <span class="label">尾房：</span>
              <span>标准月租金 * </span>
              <FormItem label="" prop="waveRentTermTail"class="w-80" >
                <Input v-model="savaData.waveRentTermTail" size="small" :disabled="isRead">
                  <span slot="append">%</span>
                </Input>
              </FormItem>
            </Col>
          </Row>
          <div class="flex">
            <span class="label">月租：</span>
            <div class="flex-item">
              <WaveRentTermMonth
                :max = 11
                :waveData="item"
                v-for="(item,i) in list"
                :disable="isRead"
                :key="`${item.start}-${item.waveValue}`"
                :i="i"
                :start="item.start"
                @add-form="addForm"
                :ref="`form${i}`"></WaveRentTermMonth>
            </div>
            </Col>
          </div>
          <p>注：月租的租期区间默认都为闭合区间，例：【0 - 3】；【4 - 6】；【7 - 11】</p>
        </div>
      </div>
      <div class="rules">
        <div class="rules-item">
          房租调幅：付款方式
        </div>
        <div class="rules-detail">
          <Row :gutter="16">
            <Col span="8">
              <span>月付：</span>
              <FormItem label="" prop="wavePayWayMonth" class="w-80">
                <Input v-model="savaData.wavePayWayMonth" size="small" :disabled="isRead">
                  <span slot="append">%</span>
                </Input>
              </FormItem>
            </Col>
          </Row>
        </div>
      </div>
      <div class="rules">
        <div class="rules-item">
          标准服务费
        </div>
        <div class="rules-detail">
          <Row :gutter="16">
            <Col span="8">
              <span>实际总房租 * </span>
              <FormItem label="" prop="serviceFeeValue" class="w-80">
                <Input v-model="savaData.serviceFeeValue" size="small" :disabled="isRead">
                  <span slot="append">%</span>
                </Input>
              </FormItem>
            </Col>
          </Row>
        </div>
      </div>
      <div class="rules">
        <div class="rules-item">
          付款方式
        </div>
        <div class="rules-detail">
          <Row :gutter="16">
            <Col span="18">
              <FormItem label="" prop="conCycleCodeList" style="width:100%">
                <CheckboxGroup v-model="savaData.conCycleCodeList">
                  <Checkbox :disabled="isRead" v-for="(item,i) in payTypeList" :label="item.value" :key="item.value">{{item.text}}</Checkbox>
                </CheckboxGroup>
              </FormItem>
            </Col>
          </Row>
        </div>
      </div>
      <div class="rules">
        <div class="rules-item">
          老客户定义
        </div>
        <div class="rules-detail">
          <Row :gutter="16">
            <Col span="10">
              <span>连续居住：前后合同间隔 ≤ </span>
              <!-- <FormItem label="" prop="continuityLive" class="w-80">
                <Select v-model="savaData.continuityLive" size="small" :disabled="isRead">
                  <Option v-for="item in daysList" :value="item.value" :key="`day${item.value}`">{{item.text}}</Option>
                </Select>
              </FormItem> -->
              <FormItem label="" prop="continuityLive" >
                <Input v-model="savaData.continuityLive" size="small" :disabled="isRead">
                </Input>
              </FormItem>
              <span>天</span>
            </Col>
            <Col span="10">
              <span>租期满一年：365天-连续居住天数 ≤ </span>
              <FormItem label="" prop="fullYear" >
                <Input v-model="savaData.fullYear" size="small" :disabled="isRead">
                </Input>
              </FormItem>
              <span>天</span>
            </Col>
          </Row>
        </div>

      </div>
      <div class="rules">
        <div class="rules-item">
          提前续约
        </div>
        <div class="rules-detail">
          <Row :gutter="16">
            <Col span="8">
              <span>合同到期</span>
              <FormItem label="" prop="renewDay" class="w-80">
                <Input v-model="savaData.renewDay" size="small" :disabled="isRead">
                </Input>
              </FormItem>
              <span>天内允许续约</span>
            </Col>
          </Row>
        </div>
      </div>
      <div class="rules">
        <div class="rules-item">
          年龄限制
        </div>
        <div class="rules-detail">
          <Row :gutter="16">
            <Col span="20">
              <span class="label">新签时，限制年龄区间</span>
              <FormItem label="" prop="ageStart" >
                <Input v-model="savaData.ageStart" size="small" :disabled="isRead">
                </Input>
              </FormItem>
              <div class="dash"><span></span></div>
              <FormItem label="" prop="ageEnd" >
                <Input v-model="savaData.ageEnd" size="small" :disabled="isRead"></Input>
              </FormItem>
              <span>岁</span>
              <div class="error-color" :class="{block:ageStartErr || ageEndErr}">请输入正确的数字</div>
            </Col>
          </Row>
        </div>
      </div>
      <div class="rules">
        <div class="rules-item">
          信用分限制
        </div>
        <div class="rules-detail">
          <Row :gutter="16">
            <Col span="10">
              <span>新签时，限制信用分不少于</span>
              <FormItem label="" prop="creditScore" class="w-80">
                <Input v-model="savaData.creditScore" size="small" :disabled="isRead">
                </Input>
              </FormItem>
              <span>分</span>
            </Col>
          </Row>
        </div>
      </div>
      <div class="rules">
        <div class="rules-item">
          支付超时扣款值
        </div>
        <div class="rules-detail">
          <Row :gutter="16">
            <Col span="8">
              <FormItem label="" prop="payOverTimeCut" class="w-80">
                <Input v-model="savaData.payOverTimeCut" size="small" :disabled="isRead">
                  <span slot="append">%</span>
                </Input>
              </FormItem>
            </Col>
          </Row>
        </div>
      </div>



      <div class="rules">
        <div class="rules-item">是否开启预订</div>
        <div class="rules-detail">
          <FormItem style="width: 100%">
            <CheckboxGroup v-model="unChoosedIsReservation" style="display: inline-block">
              <Checkbox :label="0" :disabled="isRead">不开启</Checkbox>
            </CheckboxGroup>
            <CheckboxGroup v-model="untreatedIsReservation" style="display: inline-block">
              <Checkbox :label="1" :disabled="isReservationLock || isRead">开启配置中房源预订</Checkbox>
              <Checkbox :label="2" :disabled="isReservationLock || isRead">开启待租中房源预订</Checkbox>
              <Checkbox :label="3" :disabled="isReservationLock || isRead">开启已出租房源预订</Checkbox>
            </CheckboxGroup>
          </FormItem>
        </div>
      </div>

      <div class="rules">
        <div class="rules-item">
          是否开启解约自动审核
        </div>
        <div class="rules-detail">
          <Row :gutter="16">
            <Col span="18">
              <FormItem label="" prop="" style="width:100%">
                <RadioGroup  v-model="savaData.isSurrenderAutoAudit">
                  <Radio :label=1 style="margin-right: 20px" :disabled="isRead">是</Radio>
                  <Radio :label=0 :disabled="isRead">否</Radio>
                </RadioGroup>
              </FormItem>
            </Col>
          </Row>
        </div>
      </div>

      <div class="rules">
        <div class="rules-item">提前预订天数</div>
        <div class="rules-detail">
          <FormItem label="" prop="advanceReservationDates" class="w-80">
            <InputNumber :precision=0 :max="30" :min="0" size="small" v-model="savaData.advanceReservationDates" :disabled="isRead" />

          </FormItem>
          <span>天</span>
          <span style="margin-left: 30px" class="main-color">注：当此处配置N，表示空置的房间可以预定N天之内签约</span>

        </div>
      </div>


      <div class="rules">
        <div class="rules-item">定金标准</div>
        <div class="rules-detail">
          <span>预定时，定金金额为实际月租金的</span>
          <FormItem label="" prop="depositStandard" class="w-80">
            <InputNumber :precision=0 :max="100" :min="1" size="small"  v-model="savaData.depositStandard" :disabled="isRead" />

          </FormItem>
          <span>%</span>

        </div>
      </div>





      <div class="rules">
        <div class="rules-item">
          是否开启黑名单校验
        </div>
        <div class="rules-detail">
          <Row :gutter="16">
            <Col span="18">
              <FormItem label="" prop="" style="width:100%">
                <RadioGroup  v-model="savaData.isBlackCheck">
                  <Radio :label=1 style="margin-right: 20px" :disabled="isRead">是</Radio>
                  <Radio :label=0 :disabled="isRead">否</Radio>
                </RadioGroup>
              </FormItem>
            </Col>
          </Row>
        </div>
      </div>
      <div class="text-align-c " v-if="!isRead">
        <Button class="mr20" type="primary" @click="save" :loading="loading">
          <span>保存</span>

        </Button>
        <FormItem class="check-box" label="" prop="isSynBoolean">
          <Checkbox  v-model="savaData.isSynBoolean">同步到权限内的所有项目</Checkbox>
        </FormItem>
      </div>
    </Form>
    <Button :key="'cancleEdit'" v-if="!isRead" class="edit" type="primary" @click="cancleEdit">取消</Button>
    <Button :key="'edit'" v-if="isRead" class="edit" type="primary" @click="edit" v-p="{api:'baseRule/saveBaseRule'}">编辑</Button>
  </div>
</template>

<script>
  import { getProjects, getBaseRule, saveBaseRule } from 'api/managementCenter'
  import  WaveRentTermMonth from './../components/WaveRentTermMonth'

  export default {
    name: 'basicrules',
    created(){
      this.initData()
      // for(let i=1; i<16; i++) {
      //   this.daysList.push({
      //     value:i,
      //     text:i
      //   })
      // }
      for(let i=1; i<11; i++) {
        this.monthList.push({
          value:i,
          text:i
        })
      }
    },
    components:{
      WaveRentTermMonth
    },
    data() {
      const validateRentTermYearStart = (require,value,callback) => {
        let pattern = /^[1-9]\d*$/
        if(!pattern.test(value)){
          this.rentTermYearStartErr = true
          callback(new Error(' '))
        }else{
          this.rentTermYearStartErr = false
          callback()
        }
      }
      const validateRentTermYearEnd = (require,value,callback) => {
        let pattern = /^[1-9]\d*$/
        if(pattern.test(value) && (+value >= +this.savaData.rentTermYearStart) ){
          this.rentTermYearEndErr = false
          callback()
        } else {
          this.rentTermYearEndErr = true
          callback(new Error(' '))
        }
      }
      const validateRentTermMonthStart = (require,value,callback) => {
        let pattern = /^[2-9]\d{1}$|^[1-4]\d{2}$/
        let bool = pattern.test(value) && +value < 365 && +value >=28
        if(bool){
          this.rentTermMonthEndErr = false
          callback()
        }else{
          this.rentTermMonthEndErr = true
          callback(new Error(' '))
        }
      }
      const validateRentTermMonthEnd  = (require,value,callback) => {
        let pattern = /^[3-9]\d{1}$|^[1-4]\d{2}$/
        let bool = pattern.test(value) && +value < 365 && +value > +this.savaData.rentTermMonthStart
        if(bool){
          this.rentTermMonthStartErr = false
          callback()
        } else {
          this.rentTermMonthStartErr = true
          callback(new Error(' '))
        }
      }
      const validateAgeStart = (require,value,callback) => {
        let pattern = /^[1-9]\d*$/
        if(!pattern.test(value)){
          this.ageStartErr = true
          callback(new Error(' '))
        }else{
          this.ageStartErr = false
          callback()
        }
      }
      const validateAgeEnd = (require,value,callback) => {
        let pattern = /^[1-9]\d*$/
        if(pattern.test(value) && (+value > +this.savaData.ageStart) ){
          this.ageEndErr = false
          callback()
        } else {
          this.ageEndErr = true
          callback(new Error(' '))
        }
      }
      const validateNumber = (require,value,callback) => {
        let pattern = /^[1-9]\d*$/
        if(!pattern.test(value)){
          callback(new Error(' '))
        }else{
          callback()
        }
      }
      const validateServiceFee = (require,value,callback) => {
        let pattern = /^0$|^[1-9]\d*$/
        if(pattern.test(value) && +value <=100){
          callback()
        }else{
          callback(new Error(' '))
        }
      }
      const validateWaveNumber = (require,value,callback) => {
        let pattern = /^[1-9]\d*$/
        if(pattern.test(value) && +value >=100){
          callback()
        }else{
          callback(new Error(' '))
        }
      }
      return {
        isRead: true,
        loading: false,
        list:[{
          index:0,
          start:0,
          waveValue:''
        }],
        listIndex:0,

        // 待处理的 isReservation 字段，逻辑请看 watch 对象
        untreatedIsReservation: [],
        unChoosedIsReservation: [],
        isReservationLock: false,
        savaData:{
          ageEnd: '',
          ageStart: '',
          conCycleCodeList: [],
          conCycleCode:'',
          continuityLive: '',
          creditScore: '',
          depositMonthValue: '',
          depositTailValue: '',
          depositYearValue: '',
          fullYear: '',
          isSynBoolean:false,
          isSyn: 0,
          projectFid: '',
          renewDay:'',
          rentTermMonthEnd: '',
          rentTermMonthStart: '',
          rentTermYearEnd: '',
          rentTermYearStart: '',
          serviceFeeValue:'',
          wavePayWayMonth: '', //月付
          waveRentTermMonthList: [],
          waveRentTermTail: '',
          waveRentTermYear: '',
          isBlackCheck: 0,
          payOverTimeCut:'',
          isReservation:[],
          advanceReservationDates:null,
          depositStandard:null,
          isSurrenderAutoAudit:1,
        },
        formRules:{
          rentTermYearStart: [{required: true, validator:validateRentTermYearStart,type:'number',trigger:'blur'}],
          rentTermYearEnd: [{required: true, validator:validateRentTermYearEnd,type:'number',trigger:'blur'}],
          rentTermMonthStart: [{required: true, validator:validateRentTermMonthStart,type:'number',trigger:'blur'}],
          rentTermMonthEnd: [{required: true, validator:validateRentTermMonthEnd,type:'number',trigger:'blur'}],
          depositYearValue: [{required: true, message:' ', type:'number',trigger:'change'}],
          depositMonthValue: [{required: true, message:' ', type:'number',trigger:'change'}],
          depositTailValue: [{required: true, message:' ', type:'number',trigger:'change'}],
          waveRentTermYear: [{required: true, type:'number', validator:validateWaveNumber,trigger:'blur'}],
          waveRentTermTail: [{required: true, type:'number', validator:validateWaveNumber,trigger:'blur'}],
          wavePayWayMonth: [{required: true, type:'number', validator:validateWaveNumber,trigger:'blur'}],
          serviceFeeValue:[{required: true, type:'number', validator:validateServiceFee,trigger:'blur'}], // >= 0
          conCycleCodeList:[{ required: true, type: 'array', min: 1, message: ' ', trigger: 'change' }],
          continuityLive:[{required: true, type:'number', validator:validateNumber,trigger:'blur'}],
          fullYear:[{required: true, type:'number', validator:validateNumber,trigger:'blur'}],
          renewDay:[{required: true, type:'number', validator:validateNumber,trigger:'blur'}],
          ageStart: [{required: true,type:'number', validator:validateAgeStart,type:'string',trigger:'blur'}],
          ageEnd: [{required: true, type:'number', validator:validateAgeEnd,type:'string',trigger:'blur'}],
          creditScore:[{required: true, type:'number', validator:validateNumber,trigger:'blur'}],
          payOverTimeCut:[{required: true, type:'number', validator:validateServiceFee,trigger:'blur'}],


          // isReservation: [{required: true, message:' ', type:'number',trigger:'change'}],
          advanceReservationDates: [{required: true, message:' ', type:'number',trigger:'blur'}],
          depositStandard: [{required: true, message:' ', type:'number',trigger:'blur'}],



        },
        rentTermYearEndErr:false,
        rentTermYearStartErr:false,
        rentTermMonthStartErr:false,
        rentTermMonthEndErr:false,
        ageStartErr:false,
        ageEndErr:false,
        projectList:[],
        monthList:[],
        daysList:[],
        payTypeList:[],
      }
    },
    methods:{
      initData(){
        getProjects().then( res => {
          this.projectList = res.data
          if(this.projectList.length>0) {
            this.savaData.projectFid = this.projectList[0].value
            this.getRules(this.savaData.projectFid)
          }
        })
      },
      changeProject(val){
        this.clear()
        this.getRules(val)
      },
      cancleEdit(){
        this.clear()
        this.getRules(this.savaData.projectFid)
        this.isRead = true
      },
      clear(){
        this.$refs['rulusForm'].resetFields();
        this.untreatedIsReservation = [];
        this.unChoosedIsReservation = [];
        for( let key in this.savaData) {
          switch(key){
            case 'projectFid':
              break;
            case 'conCycleCodeList':
              this.savaData[key].length = 0
              break;
            case 'waveRentTermMonthList':
              this.savaData[key].length = 0
              break;
            case 'isSyn':
              this.savaData[key] = 0;
              break;
            case 'isSynBoolean':
              this.savaData[key] = false;
              break;
            case 'depositStandard'||'advanceReservationDates':
              this.savaData[key] = null;
              break;
            case 'isReservation':
              this.savaData[key] = [];
              break;

            default:
              this.savaData[key] = null;
          }
        }
        this.rentTermYearEndErr = false
        this.rentTermYearStartErr = false
        this.rentTermMonthStartErr = false
        this.rentTermMonthEndErr = false
        this.ageStartErr = false
        this.ageEndErr = false
        this.isRead = true
        this.list = [{
          index:0,
          start:0,
          waveValue:''
        }]
      },
      changeIsReservation(value) {
        switch (true) {
          case (value[0] === 0):
            this.unChoosedIsReservation = [0];
            break;
          default:
            this.untreatedIsReservation = value;
        }
      },
      getRules(projectFid){
        getBaseRule(projectFid).then( res => {
          if( res.data.baseRuleDto) {
            // for(let key in res.data.baseRuleDto) {
            //   if(key === 'projectFid') continue;
            //   this.savaData[key] = res.data.baseRuleDto[key]
            // }
            this.savaData = res.data.baseRuleDto
            this.changeIsReservation(this.savaData.isReservation);

            let conCycleCodeList = res.data.baseRuleDto.conCycleCode.split(',').map(item => {
              return +item
            })
            // let isSynBoolean = res.data.baseRuleDto.isSyn ? true : false
            this.$set(this.savaData,'conCycleCodeList',conCycleCodeList)
            this.$set(this.savaData,'isSynBoolean',false)
            this.list =  res.data.baseRuleDto.waveRentTermMonthList
          }
          this.payTypeList = res.data.paymentCycleEnums
        })
      },
      addForm(data){
        let start = data.preEnd + 1
        this.listIndex = data.i + 1
        this.list.splice(this.listIndex)
        if(start == 12) return
        this.list.push({
          start: start,
          end:'',
          waveValue:''
        })
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
      },
      edit(){
        this.isRead = false
      },
      validateWaveRentTermMonth() {
        let waveRentTermMonthList = []
        let result = this.list.every( (item,i) => {
          waveRentTermMonthList.push(this.$refs[`form${i}`][0].formValidate())
          return this.$refs[`form${i}`][0].formValidate()
        })
        if(result) {
          return waveRentTermMonthList
        }else{
          return false
        }
      },
      save(){
        let result = this.validateWaveRentTermMonth()
        this.$refs[`rulusForm`].validate(bool => {
          if(bool){
            let result = this.validateWaveRentTermMonth()
            if(!result) {
              return
            } else {

              this.savaData.conCycleCode = this.savaData.conCycleCodeList.join(',')
              this.savaData.waveRentTermMonthList = result
              if(this.savaData.isSynBoolean){
                this.savaData.isSyn = 1
              } else {
                this.savaData.isSyn = 0
              }
              this.loading = true
              saveBaseRule(this.savaData).then( res => {
                this.$Message.success('保存成功');
                this.loading = false;
                this.isRead = true
              }).catch( res => {
                this.loading = false;
              })
            }
          } else {
            this.$Message.info('请检查输入！')
          }
        })
      }
    },
    watch: {
      unChoosedIsReservation: {
        handler: function (value) {
          switch (true) {
            case (value.includes(0)):
              this.untreatedIsReservation = [0];
              this.isReservationLock = true;
              break;
            default:
              this.untreatedIsReservation = [];
              this.isReservationLock = false;
          }
        },
        deep: true,
        immediate: true,
      },
      untreatedIsReservation: {
        handler: function (value) {
            console.info(value[0])
            this.savaData.isReservation = value;
        },
        deep: true,
        immediate: true,
      }
    }
  }
</script>

<style scoped>
  .ivu-form-item {
    display: inline-block;
    width: 60px;
  }
  .rules {
    display: flex;
    margin-top: 16px;

  }
  .mt-36{
    margin-top:36px;
  }
  .rules-item {
    width: 140px;
    line-height: 32px;
    font-weight: 600;
  }
  .rules-detail {
    flex:1;
  }
  .rules-detail span {
    display: inline-block;
    line-height: 32px;
  }
  .ivu-input-group-append span {
    line-height: 1;
  }

  .label {
    padding-right:10px;
  }
  .dash {
    display: inline-block;
    padding-left: 4px;
    padding-right: 4px;
    text-align: center;
  }
  .dash span {
    display: inline-block;
    width: 8px;
    height: 2px;
    background: #dddee1;
    vertical-align: middle;
  }
  .w-80 {
    width: 80px;
  }

  .error-color{
    position: absolute;
    bottom: 0;
    display: none;
  }
  .block {
    display: block;
  }
  .ivu-checkbox-wrapper {
    margin-right: 32px;
  }
  .flex {
    display: flex;

  }
  .flex-item {
    flex: 1
  }
  p {
    color:#CFA868;
    margin-bottom: 24px;
  }
  .edit {
    position:absolute;
    top: 60px;
    right: 24px;
  }
  .check-box {
    width:auto;
  }

  .main-color{
    color:#CFA868;
  }

</style>

